import ReactGA from "react-ga4";

export const initGA = (idGoogleAnalytics) => {
    ReactGA.initialize(`${idGoogleAnalytics}`); // Reemplaza con tu ID de seguimiento
};

export const logPageView = () => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};
